/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';
import { type SlackWorkspace } from '../../types';
import { cssMap, jsx } from '@atlaskit/css';
import { Inline } from '@atlaskit/primitives/compiled';
import Select, { type ValueType } from '@atlaskit/select';
import { token } from '@atlaskit/tokens';
interface OwnProps {
	slackWorkspaces: SlackWorkspace[];
	selectedOption: SlackWorkspace | null;
	onSelect: (option: SlackWorkspace) => void;
}

const styles = cssMap({
	optionWrapper: {
		// overflow: 'hidden',
	},
	image: {
		width: '20px',
		height: '20px',
		paddingRight: token('space.100', '8px'),
	},
});

const SlackWorkspacesDropdown: React.FC<OwnProps> = ({
	slackWorkspaces,
	selectedOption,
	onSelect,
}) => {
	const formatOptionLabel = (option: SlackWorkspace) => {
		return (
			<Inline xcss={styles.optionWrapper}>
				<img alt={option.avatar} src={option.avatar} css={styles.image} />
				{option.name}
			</Inline>
		);
	};

	return (
		<Select<SlackWorkspace>
			name="slack-workspace-select"
			isSearchable={false}
			value={selectedOption}
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
			className="single-select"
			classNamePrefix="react-select"
			getOptionValue={(w) => w.id}
			options={slackWorkspaces}
			formatOptionLabel={formatOptionLabel}
			isDisabled={slackWorkspaces.length === 1}
			onChange={(selectedSlackWorkspace: ValueType<SlackWorkspace>) =>
				onSelect(selectedSlackWorkspace as SlackWorkspace)
			}
		/>
	);
};

export default SlackWorkspacesDropdown;
